import axios from "axios";
import { jwtDecode } from "jwt-decode";

const AuthServices = {
  signIn: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/auth/login",
      {
        username: data.username,
        password: data.password,
      }
    );

    return response;
  },
  signUp: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/auth/register",
      {
        username: data.username,
        password: data.password,
        role: data.role,
        ...(data.hash ? { hash: data.hash } : null),
        ...(data.first_name ? { first_name: data.first_name } : null),
        ...(data.last_name ? { last_name: data.last_name } : null),
        ...(data.country_code ? { country_code: data.country_code } : null),
        ...(data.birth ? { birth: data.birth } : null),
      }
    );
    return response;
  },
  verifyInvite: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/service/verify-invite",
      {
        hash: data.hash,
      }
    );
    return response;
  },
  activate: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/auth/activate",
      {
        activation_code: data.activation_code,
      }
    );
    return response;
  },
  forgotPassword: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/auth/forgot-password",
      {
        username: data.username,
      }
    );
    return response;
  },
  changePassword: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/auth/change-password",
      {
        password: data.password,
        new_password: data.new_password,
      }
    );
    return response;
  },
  changePasswordForUser: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/auth/change-password",
      {
        patient: data.patient,
        new_password: data.new_password,
      }
    );
    return response;
  },
  forgotPasswordCode: async (data) => {
    const response = await axios.put(
      process.env.REACT_APP_API_URL + "/auth/forgot-password",
      {
        username: data.username,
        code: data.code,
      }
    );
    return response;
  },
  setRemember: (remember) => {
    localStorage.setItem("remember_me", remember ? "true" : "false");
  },
  getRemember: (remember) => {
    if (localStorage.getItem("remember_me") === undefined) {
      return null;
    }
    return localStorage.getItem("remember_me") === "true";
  },
  refreshToken: async (error) => {
    return new Promise((resolve, reject) => {
      try {
        const refresh_token = AuthServices.getRefreshToken();

        axios
          .post(process.env.REACT_APP_API_URL + "/auth/refresh-token", {
            "refresh-token": refresh_token,
          })
          .then(async (res) => {
            if (res.data.access_token && res.data.refresh_token) {
              AuthServices.setToken(res.data.access_token);
              AuthServices.setRefreshToken(res.data.refresh_token);
            }
            return resolve(res);
          })
          .catch((err) => {
            return reject(error);
          });
      } catch (err) {
        return reject(err);
      }
    });
  },
  setRefreshToken: (token) => {
    const remember = AuthServices.getRemember();
    if (remember === true) {
      localStorage.setItem("refreshToken", token);
    } else if (remember === false) {
      sessionStorage.setItem("refreshToken", token);
    }
  },
  getRefreshToken: () => {
    const remember = AuthServices.getRemember();
    if (remember === true) {
      return localStorage.getItem("refreshToken");
    } else if (remember === false) {
      return sessionStorage.getItem("refreshToken");
    }
  },
  removeRefreshToken: () => {
    localStorage.getItem("refreshToken");
    sessionStorage.getItem("refreshToken");
  },
  setToken: (token) => {
    const remember = AuthServices.getRemember();
    if (remember === true) {
      localStorage.setItem("accessToken", token);
    } else if (remember === false) {
      sessionStorage.setItem("accessToken", token);
    }
  },
  getToken: () => {
    const remember = AuthServices.getRemember();
    if (remember === true) {
      return localStorage.getItem("accessToken");
    } else if (remember === false) {
      return sessionStorage.getItem("accessToken");
    }
  },
  removeToken: () => {
    localStorage.removeItem("accessToken");
    sessionStorage.removeItem("accessToken");
  },
  setUser: (username) => {
    localStorage.setItem("username", username);
  },
  getUser: () => {
    return localStorage.getItem("username");
  },
  getRole: () => {
    var decoded = jwtDecode(AuthServices.getToken());
    return decoded.resource_access["eira-backend"].roles[0];
  },
  register: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/auth/register",
      {
        username: data.username,
        password: data.password,
        role: data.role,
      }
    );

    return response;
  },
  getTerms: async (data) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/service/invite-admin-enterprise?hash=${data.hash}&email=${data.email}`
    );

    return response;
  },

  validateCaptcha: async (token) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/eira/validate-recaptcha",
      {
        recaptcha_response: token,
      }
    );

    return response;
  },

  keycloakLoginSSO: async (code) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/service/keycloak-login-sso?code=${code}`
    );

    return response;
  },
};

export default AuthServices;
